import { useWrapRequest } from 'use-wrap-request';
import { Api } from '../../../core/api';
import { injectTSDI } from '../../../core/tsdi';
import { CommunityLeaderboardSettingsUpdateRequest } from '../../../core/api/ChallengeClient';

export function useCommunitySettingsStore() {
    const { challengeClient } = injectTSDI(Api);

    const communitySettings = useWrapRequest(
        async (
            communityId: number
        ) => {
            const result = await challengeClient.support.communitySettingsSupportControllerGetGeneralSettings(
                communityId
            );
            return result.data;
        },
        {
            defaultData: null
        }
    );

    const leaderboardSettings = useWrapRequest(
        async (
            communityId: number
        ) => {
            const result = await challengeClient.support.communitySettingsSupportControllerGetLeaderboardSettings(
                communityId
            );
            return result.data;
        },
        {
            defaultData: null
        }
    );

    const updateLeaderboardSettings = useWrapRequest(
        async (communityId: number, data: CommunityLeaderboardSettingsUpdateRequest) => {
            const result = await challengeClient.support.communitySettingsSupportControllerUpdateLeaderboardSettings(
                communityId,
                data
            );
            return result.data;
        },
        {
            defaultData: null
        }
    );

    const triggerTenantMemberSync = useWrapRequest(
        async (communityId: number) => {
            const result = await challengeClient.support.communitySupportControllerTriggerTenantMembersSynchronization(
                communityId
            );
            return result.data;
        },
        {
            defaultData: null
        }
    );

    const handleUpdateLeaderboardSettings = async (
        communityId: number,
        data: CommunityLeaderboardSettingsUpdateRequest
    ) => {
        await updateLeaderboardSettings.request([communityId, data]);
        // Refetch the leaderboard settings after update
        await leaderboardSettings.request([communityId]);
    };

    const handleTriggerTenantMemberSync = async (communityId: number) => {
        await triggerTenantMemberSync.request([communityId]);
    };

    return {
        communitySettings,
        leaderboardSettings,
        updateLeaderboardSettings,
        handleUpdateLeaderboardSettings,
        triggerTenantMemberSync,
        handleTriggerTenantMemberSync
    };
}
